module.exports = __webpack_public_path__ + "static/img/medicalrecords.e0adcbe.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/medicalrecords.jpeg
// module id = AWn0
// module chunks = 7